// ============================================================
// EDITABLE COPY — testimonials, FAQ, destinations and features.
// Text in [square brackets] is a placeholder: replace with your real details.
// ============================================================
import { IMAGES } from "./site";

export const WHY_ITEMS = [
  { icon: "Clock", title: "Available 24/7", text: "Early flight or late ferry. We are there, day and night." },
  { icon: "PlaneLanding", title: "Flight tracking", text: "We follow your flight and adjust to delays. No stress." },
  { icon: "Signature", title: "Meet & greet", text: "A name sign at arrivals, on request. Easy to spot." },
  { icon: "GlassWater", title: "Free bottled water", text: "Chilled water waiting for you on every ride." },
  { icon: "Baby", title: "Free child seats", text: "Safe seats for little travellers, at no extra cost." },
  { icon: "BadgeEuro", title: "Fixed, transparent prices", text: "The price you see is the price you pay. Per vehicle." },
  { icon: "Languages", title: "English & Greek speaking", text: "A friendly local driver who knows every corner." },
];

export const STEPS = [
  { n: "01", title: "Book", text: "Choose your route, date and time online in under two minutes." },
  { n: "02", title: "We track your flight", text: "Delayed? We know. Your driver adjusts automatically." },
  { n: "03", title: "Relax and arrive in style", text: "Step into a cool, spotless vehicle and enjoy the ride." },
];

// GUEST REVIEWS from Tripadvisor (driver's name replaced with "the driver").
export const TESTIMONIALS = [
  { title: "The most amazing driver", quote: "The driver was incredible!! Soo kind and genuinely a lovely and attentive driver. So so impressed and when I go back to Rhodes I will be getting in touch as he was incredible!", name: "Daisy P", origin: "England", date: "April 2026" },
  { title: "Great Host and Wonderful Journey", quote: "Great experience traveling with my family. The host was very kind, welcoming, and professional. Everything went smoothly and we really enjoyed the trip. Highly recommended!", name: "Jana G", origin: "Germany", date: "May 2026" },
  { title: "Best drivers!", quote: "Legit the nicest people! They help you get a special feeling that theyre there for you and your friends ❤️", name: "David Busch G", origin: "Norway", date: "June 2026" },
];

export const FAQS = [
  { q: "How do I pay?", a: "You choose. Pay securely online by card when you book, or pay the driver on the day in cash or by card." },
  { q: "Are child seats really free?", a: "Yes. Child seats and boosters are free of charge. Just tell us how many you need when you book." },
  { q: "What if my flight is delayed?", a: "Flight tracking is included. We follow your flight and adjust the pickup time automatically, at no extra cost." },
  { q: "What is your cancellation policy?", a: "Free cancellation up to [24] hours before pickup. Online payments are refunded in full within that window. [Edit this policy to match your terms.]" },
];

// Tour options shown on the Tours page. `id` must match the backend tour types.
export const TOUR_PLANS = [
  { id: "lindos", title: "City to Lindos", text: "From Rhodes Town along the east coast to Lindos. Walk the white village, climb to the Acropolis and swim at St Paul's Bay.", img: IMAGES.lindos },
  { id: "butterfly_valley", title: "City to Butterfly Valley", text: "From Rhodes Town into the green heart of the island. Shaded paths, streams and wooden bridges at the Valley of the Butterflies.", img: IMAGES.butterflies },
  { id: "custom", title: "Custom tour", text: "You tell us what you want to see. We plan the route, the stops and the timing around you.", img: IMAGES.coast },
];

export const VEHICLES = [
  { id: "sedan", title: "Sedan", seats: 4, text: "Elegant and discreet. Ideal for couples and small families.", img: IMAGES.sedan },
  { id: "van", title: "Van", seats: 8, text: "Space for families and friends, with plenty of room for luggage.", img: IMAGES.vehicle },
  { id: "minibus", title: "Minibus", seats: 12, text: "For larger groups who want to travel together, in comfort.", img: IMAGES.minibus },
];

export const TOUR_INTERESTS = ["History & monuments", "Beaches & swimming", "Food & wine", "Villages", "Photography", "Nature & hiking", "Family friendly", "Sunset"];

export const EXTRAS = [
  { icon: "GlassWater", label: "Free bottled water" },
  { icon: "Baby", label: "Child seats on request" },
  { icon: "PlaneLanding", label: "Flight tracking" },
  { icon: "Signature", label: "Meet & greet with name sign on request" },
];

export const FLEET_FEATURES = [
  { icon: "Users", title: "Always private", text: "Your vehicle is never shared with other guests." },
  { icon: "Snowflake", title: "Air conditioned", text: "Cool and comfortable, even in the August heat." },
  { icon: "Luggage", title: "Generous luggage space", text: "Suitcases, strollers and beach bags, no problem." },
  { icon: "Baby", title: "Child seats on request", text: "Free of charge, fitted before you arrive." },
  { icon: "Sparkles", title: "Spotless, every ride", text: "Cleaned and prepared before every transfer." },
  { icon: "ShieldCheck", title: "Licensed & insured", text: "Professional and fully insured." },
  { icon: "Wifi", title: "Free Wi-Fi", text: "Stay connected on the road and share your first photos." },
  { icon: "BatteryCharging", title: "Phone chargers", text: "Charge your phone on the way to your hotel." },
];
